










































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentLiberarRepasseMultiplo extends Vue {
  tableHeaders: any[] = [
    { text: 'Fonte Pagadora', value: 'fontePagadoraNome', align: 'left', sortable: false },
    { text: 'Prestador', value: 'prestadorNome', align: 'left', sortable: false },
  ]

  loadLiberarRepasseMultiplo: boolean = false

  get showModalLiberarRepasseMultiplo() { return this.getFinanceiroStore.modal.liberarRepasseMultiplo }
  set showModalLiberarRepasseMultiplo(value: boolean) { this.getFinanceiroStore.setModal({ name: 'liberarRepasseMultiplo', value }) }

  get loadingLiberarRepasseMultiplo() { return this.loadLiberarRepasseMultiplo }
  set loadingLiberarRepasseMultiplo(value: boolean) { this.loadLiberarRepasseMultiplo = value }

  get repassesAptosALiberar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.every((item: any) => item.acoes.PodeLiberar) }
  get repassesNaoAptosALiberar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.filter((item: any) => !item.acoes.PodeLiberar) || [] }

  async liberarRepasseMultiplo() {
    this.loadingLiberarRepasseMultiplo = true
    const response = await this.getFinanceiroStore.liberarItensDeGeracaoDeRepasseNoHis()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao liberar o(s) repasse(s).', icon: 'warning', color: '#C62828' })
      this.loadingLiberarRepasseMultiplo = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'A liberação do(s) repasse(s) foi iniciada!', icon: 'done', color: '#2E7D32' })
    this.showModalLiberarRepasseMultiplo = false
    // FXSR-2699 — a geração já continuava aberta aqui; recarrega a lista para refletir o que a
    // liberação (assíncrona no HIS) já mudou.
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse)
    this.loadingLiberarRepasseMultiplo = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
